import React from 'react'
import moment from 'moment';
const ModuleDisplayDateTime = ({ value }) => {
    return (
        <>{(value) ? (moment(value).format("DD MMMM YYYY HH:mm")) : null}</>
    )
}

export default ModuleDisplayDateTime